export default __webpack_public_path__ + "static/media/allMetalParts.89b49ddc.jpg";